module.exports = __webpack_public_path__ + "img/45_BF23_dont_fear_the_weather.071d170d.jpg";